import type {
  campaignDetailResource,
  campaignResource,
} from '@porotutu/api/features/crm/campaigns/resource'
import { exportHrefFor, unwrap } from '@porotutu/react/api'
import type { ListMeta, ListQuery } from '@porotutu/react/paging'
import { keepPreviousData, queryOptions } from '@tanstack/react-query'
import { crm } from '@/api/client'
import { CAMPAIGNS } from '@/api/keys'
import type { CampaignType, CrmCampaignSort } from '../vocabulary'

export type Campaign = ReturnType<typeof campaignResource>

export type CampaignDetail = ReturnType<typeof campaignDetailResource>

export type CampaignPage = { data: Campaign[]; meta: ListMeta }

export const ACTIVITY = ['true', 'false'] as const

export type Activity = (typeof ACTIVITY)[number]

export type CampaignListQuery = ListQuery<CrmCampaignSort, never> & {
  campaign_type?: CampaignType
  active?: Activity
}

export const sentQuery = ({ active, ...rest }: CampaignListQuery) => ({
  ...rest,
  active: active === undefined ? undefined : active === 'true',
})

export const campaignsQuery = (query: CampaignListQuery) =>
  queryOptions({
    queryKey: [...CAMPAIGNS, 'list', query] as const,
    queryFn: async () => unwrap(await crm.campaigns.get({ query: sentQuery(query) })),
    placeholderData: keepPreviousData,
    staleTime: 15_000,
  })

export const campaignQuery = (id: string) =>
  queryOptions({
    queryKey: [...CAMPAIGNS, 'record', id] as const,
    queryFn: async () => unwrap(await crm.campaigns({ id }).get()),
    staleTime: 30_000,
  })

export const exportHref = exportHrefFor<CampaignListQuery>('/api/v1/crm/campaigns/export', {
  always: [],
  viewed: ['campaign_type', 'active', 'search'],
})
